// ABOUTME: Flat single-item carousel -- one centered item, no arrows and no ring geometry; the console card's picker drives it.
// ABOUTME: Replaces DialRing (S25 correction): bryan confirmed the real chrome shows one item at a time (Issue #1945).

import type { ReactNode } from 'react';
import { Box } from '@mui/material';

interface ReadingCarouselProps<T> {
  items: T[];
  activeIndex: number;
  // Renders the centered item (icon + name) -- content-agnostic, same as the item shown is the
  // only piece of state visible; there is no onPick, since nothing else is ever on screen to tap.
  renderItem: (item: T) => ReactNode;
  reducedMotion?: boolean;
}

export default function ReadingCarousel<T>({ items, activeIndex, renderItem, reducedMotion }: ReadingCarouselProps<T>) {
  const item = items[activeIndex];
  // Transition between items is low-confidence per the spec (static screenshots only show settled
  // state) -- a simple crossfade consistent with the theme's other 0.3-0.5s ease transitions,
  // collapsing to instant under reduced motion.
  const transition = reducedMotion ? 'none' : 'opacity 0.4s ease';

  return (
    <Box data-testid="reading-carousel" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, width: '100%', maxWidth: 420 }}>
      <Box key={activeIndex} data-testid="reading-carousel-item" sx={{ transition }}>
        {item && renderItem(item)}
      </Box>
    </Box>
  );
}
